var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lang-select-container mt-5"},[_c('v-select',{attrs:{"dense":"","outlined":"","rounded":"","items":_vm.languages,"value":_vm.selected},on:{"change":_vm.onSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }